module.exports = __webpack_public_path__ + "static/img/culture-value.bfd1b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture-value.png
// module id = cH5t
// module chunks = 0